import SceButton from '../../../../../Common/CommonComponents/sceButton';
import { getLocalizedStrings } from '../../twoFactorAuthenticationStrings';
import classes from '../../twoFactorAuthContainer.scss';
import TwoFactorAuthCodeTextBox from '../../Common/twoFactorAuthCodeTextBox';

function EmailStepTwo(props) {
    let strings = getLocalizedStrings('twoFactorAuthenticationStrings');
    let warningImg = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Warning.svg';
    const resendVerification = props.resendExceedMsg ?
    <div className={["sce-content-row", 'sce-center-alg'].join(" ")}><a className={classes.disabledSendCode}> {strings.resendCode}</a> <br />
        <span><img src={warningImg} alt="Warning Image" /></span>
        <span className={classes.errMsg}> {props.resendExceedMsg}</span>
    </div>
    :
    <div className={["sce-content-row", 'sce-center-alg', classes.centeraligned].join(" ")}> <a className={classes.sendCode}  href="JavaScript:void(0)" onClick={props.resendCodeHandler}> {strings.resendCode}</a></div>; 
    const invalidCodeErrormsg =   props.invalidCodeError ?
        <div className={"sce-content-row"}>
                <div className={classes.errorContainer}>
                   <div> <img src={warningImg} alt="Warning Image" /> </div>
                    <div className={["sce-caret", classes.errMsg].join(" ")}>
                    {strings.invalidVerifyCode}
                    </div> 
                </div>
        </div>
        : null ;
    const tryAgain = !props.resendSuccess ?
        <div className={"sce-content-row"}>
            <div className={classes.errorContainer}>
                <div> <img src={warningImg} alt="Warning Image" /> </div>
                <div className={["sce-caret", classes.errMsg].join(" ")}>
                    {strings.tryAgain}
                </div>
            </div>
        </div>
        : null;
    return (
        <div className={classes.emailStepTwo}>   
        <div className={classes.enterVerifyCode}>
            <div className={[classes.verifyLogIn, classes.verifyBtnFlex, 'sce-center-alg'].join(" ")}> {strings.enterVerificationCode}
                <div className={[classes.verifyAddress, "sce-content-row"].join(" ")}> {props.formatEmailIdWithStar(props.userEnteredValue)}
                </div>
            </div>
            <div className={["sce-content-row", classes.subTextCodeReceived].join(" ")}>  {strings.enterVerificationCodeReceived}
                <div className={["sce-content-row", classes.verificationCode].join(" ")}> {strings.verificationCode}
                    <div className={classes.textBoxTopMargin}>
                        <TwoFactorAuthCodeTextBox
                            type={"verificationCodeSms"}
                            id={'verificationCode'}
                            validator={app.appUtil.validator}
                            maxLength={props.textEmailPinLength}
                            onChangeVerifyHandler={props.onChangeHandler}
                        />
                    </div>
                    {invalidCodeErrormsg}
                    <div className={["sce-content-row", 'sce-center-alg', classes.verifyBtn].join(" ")}>
                        <SceButton id='VerfiyCode' isDisabled={(props.disableVerifyBtn) ? true : false}
                            buttonType={(props.disableVerifyBtn) ? 'sceDisabled' : 'primary'}
                            value={strings.verify} onClick={props.verifyCodeHandler} />
                    </div>
                    {resendVerification}
                    {tryAgain}
                </div>
            </div>
        </div>
        </div>
    );
}
export default EmailStepTwo;